export default {
  created () {
    let url = window.location.hostname
    if (url.includes("smfmotor")) {
      document.title = "SMF Customer Portal"
    }
  }
}